import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledCardBadge = styled.div`
  ${({ theme }) => {
    const resultPosition = utils.rem(theme.Spacing.Size.XSmall);
    const resultPadding = utils.rem(theme.Spacing.Size.XXSmall);

    return `
        display: inline-block;
        transition: all 0.5s;
        position: absolute;
        bottom: ${resultPosition};
        right: ${resultPosition};
        width: ${utils.rem(theme.Spacing.Size.Medium)};
        display: flex;
        border-radius: ${utils.rem(theme.Border.Radius.XLarge)};
        background-color: ${theme.Color.NeutralsFixed.Gray};
        padding: ${resultPadding};
        gap: ${resultPadding};
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        z-index: ${theme.ZIndex.ZIndex.Elevated}; 

        &:hover {
          width: ${utils.rem(theme.Spacing.Size.XXLarge)};
          justify-content: center;
        };
  `;
  }}
`;

export const StyledCardBadgeIcon = styled.div`
  line-height: 0;
`;

export const StyledCardBadgeLabel = styled.div`
  overflow: hidden;
  transition: opacity 0.3s ease, max-height 0.3s ease;
`;
